import { Suspense, useEffect } from 'react';
import { Route, Routes } from 'react-router-dom';

import AuthRequired from '@/components/globals/AuthRequired';
import { ACCOUNTS_ENV } from '@/env';
import useGoogleAnalytics from '@/hooks/useGoogleAnalytics';
import { useSentryTagsSetter } from '@/hooks/useSentryTagsSetter';
import { testFlagsStore } from '@/stores/testFlags';

import BlululupContainer from './Blululup';
import CreateProduct from './CreateProduct';
import Home from './Home';
import ProducerDataContainer from './ProducerData';
import ProductCompletion from './ProductCompletion';
import ProfileTypes from './ProfileTypes';
import '../lib/clarity';

export default function Pages() {
  useGoogleAnalytics();
  useSentryTagsSetter();

  useEffect(() => {
    if (ACCOUNTS_ENV === 'prod') {
      return;
    }

    const queryParams = new URLSearchParams(window.location.search);
    const aiDeliverablesErrorTestMode = queryParams.get('aiDeliverablesErrorTestMode') === 'true';

    const state = testFlagsStore.getState();
    state.setAIDeliverablesErrorTestMode(aiDeliverablesErrorTestMode);
  }, []);

  useEffect(() => {
    if (ACCOUNTS_ENV !== 'prod') {
      const state = testFlagsStore.getState();
      console.log('TEST FLAGS:', { state });
    }
  });

  return (
    <main className='flex h-full w-full flex-col'>
      <Suspense>
        <Routes>
          <Route element={<AuthRequired />}>
            <Route path='/profile-types' element={<ProfileTypes />} />
            <Route path='/blululup' element={<BlululupContainer />} />
            <Route path='/producer-data' element={<ProducerDataContainer />} />
            <Route path='/product/:id/created' element={<ProductCompletion />} />
            <Route path='/product/create' element={<CreateProduct />} />
            <Route path='/' element={<Home />} />
          </Route>

          <Route path='*' element={<h1>404</h1>} />
        </Routes>
      </Suspense>
    </main>
  );
}
